import React from "react";
import SettingsModal from "../components/modals/settings";
import axios from "../utils/axiosConfig";
import ModalBaseSm from "./../components/modals/modal-base-sm";
import FormUpdatePassword from "../components/formsSolicitudes/formUpdatePassword";
import "../Pages/Css/navbarPrincipal.css";
import Swal from "sweetalert2";
import { logAvailableVoices, showNotificationSpeech } from "./../utils/notifications";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { getBrowserTimeZone, getCurrentTimeZoneData } from "../utils/timezones";
import { formattedGlobalDate } from "../utils/formattedDates";

import {
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    Input,
    Button,
} from "reactstrap";
import { fi } from "date-fns/locale";

const server = localStorage.getItem("server");
const userName = localStorage.getItem("username");
const empresa = localStorage.getItem("empresa");

const formatNotificationEventDate = (value) => {
    const match = String(value || "").trim().match(
        /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/
    );

    if (!match) return formattedGlobalDate(value);

    const [, year, month, day, hour, minute, second = "00"] = match;
    const colombiaTimestamp = Date.UTC(
        Number(year),
        Number(month) - 1,
        Number(day),
        Number(hour) - 5,
        Number(minute),
        Number(second)
    );

    return formattedGlobalDate(new Date(colombiaTimestamp).toISOString());
};

class BarraTrafico extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openModal: false,
            openModalChangePassword: false,

            // Desktop dropdown
            showNotificationDropdown: false,

            // Mobile offcanvas
            offcanvasOpen: false,
            offcanvasUser: false,

            solicitudes: [],
            notifications: [],
            filteredNotiofications: [],
            hasNewNotification: false,

            confirmacionIndex: null,
            animatingIndex: null,

            userSolicitud: localStorage.getItem("username"),

            bitOpen: false,
            bitInsert: false,
            bitEdit: false,
            bitDelete: false,

            audioReady: false,
            currentTime: new Date(),

            isMobile: window.matchMedia("(max-width: 768px)").matches,
        };

        this.dropdownRef = React.createRef();
        this.bellIconRef = React.createRef();

        this.instanceId = `barra-trafico-${Date.now()}-${Math.random().toString(36).slice(2)}`;
        this.socket = null;
        this.notificationSocket = null;
        this.liveNotificationSocket = null;
        this.notificationSound = new Audio("/audio/notificationpush.mp3");
        this.notificationRetryCount = 0;
        this.liveRetryCount = 0;
        this.notificationRetryTimer = null;
        this.liveRetryTimer = null;
        this.notificationSpeechQueue = Promise.resolve();
        this.spokenNotificationIds = new Map();
        this.spokenTtlMs = 5 * 60 * 1000;
        this.sessionConnKey = "notificationSocketConnections";

        this.logout = this.logout.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.openModalChangePassword = this.openModalChangePassword.bind(this);
        this.closeModalChangePassword = this.closeModalChangePassword.bind(this);

        this.toggleNotificationDropdown = this.toggleNotificationDropdown.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleResize = this.handleResize.bind(this);

        this.toggleOffcanvas = this.toggleOffcanvas.bind(this);

        this.HandlePageByRole();
    }

    handleResize() {
        const isMobile = window.matchMedia("(max-width: 768px)").matches;

        // Si cambia de mobile a desktop, aseguramos cerrar offcanvas
        this.setState((prev) => {
            const next = { isMobile };

            if (!isMobile && prev.offcanvasOpen) next.offcanvasOpen = false;
            if (isMobile && prev.showNotificationDropdown) next.showNotificationDropdown = false;

            return next;
        });
    }

    toggleOffcanvas() {
        this.setState((prev) => ({
            offcanvasOpen: !prev.offcanvasOpen,
            hasNewNotification: false,
            // Si abres offcanvas, aseguras cerrar dropdown
            showNotificationDropdown: false,
        }));
    }

    getBackoffDelay = (attempt, baseMs = 1000, maxMs = 30000, jitter = 0.2) => {
        const exp = Math.min(maxMs, baseMs * Math.pow(2, attempt));
        const rand = exp * jitter * (Math.random() * 2 - 1);
        return Math.max(0, Math.round(exp + rand));
    };

    ensureLiveToastStyles = () => {
        if (document.getElementById("live-toast-styles")) return;
        const style = document.createElement("style");
        style.id = "live-toast-styles";
        style.innerHTML = `
            @keyframes liveToastProgress {
                from { width: 100%; }
                to { width: 0%; }
            }
            @keyframes liveToastPulse {
                0% { transform: scale(1); opacity: 1; }
                50% { transform: scale(1.35); opacity: 0.55; }
                100% { transform: scale(1); opacity: 1; }
            }
        `;
        document.head.appendChild(style);
    };

    showSecurityLiveToast = (notification) => {
        const rawAlertValue =
            notification?.alertValue ??
            notification?.AlertValue ??
            notification?.data?.alertValue ??
            notification?.data?.AlertValue;
        const normalizedValue = String(rawAlertValue).trim().toLowerCase();
        const isLiveStarted = rawAlertValue === true || normalizedValue === "true" || normalizedValue === "1";
        const deviceId = String(
            notification?.FkLokDeviceID ||
            notification?.fkLokDeviceID ||
            notification?.deviceId ||
            notification?.deviceID ||
            notification?.data?.FkLokDeviceID ||
            notification?.data?.deviceId ||
            ""
        ).trim();
        const streamId = String(
            notification?.streamId ||
            notification?.streamID ||
            notification?.streamUrl ||
            notification?.streamURL ||
            notification?.url ||
            notification?.data?.streamId ||
            notification?.data?.streamID ||
            notification?.data?.streamUrl ||
            notification?.data?.streamURL ||
            notification?.data?.url ||
            ""
        ).trim();
        const message =
            notification?.Notificacion ||
            notification?.NotificacionCliente ||
            (isLiveStarted
                ? "Este dispositivo comenzó un live."
                : "El live del dispositivo terminó.");
        const durationMs = 5000;
        const openLiveHandler =
            typeof this.props.onOpenLive === "function"
                ? this.props.onOpenLive
                : typeof this.props.onLiveNow === "function"
                    ? this.props.onLiveNow
                    : null;
        const canOpenLive = isLiveStarted && typeof openLiveHandler === "function" && !!deviceId;

        this.ensureLiveToastStyles();

        toast.custom(
            (t) => (
                <div
                    onClick={() => {
                        if (!canOpenLive) return;
                        toast.dismiss(t.id);
                        openLiveHandler({
                            ...notification,
                            deviceId,
                            streamId,
                        });
                    }}
                    style={{
                        cursor: canOpenLive ? "pointer" : "default",
                        background: "#fff",
                        color: "#111",
                        padding: "10px 14px",
                        borderRadius: 10,
                        boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                        borderLeft: `4px solid ${isLiveStarted ? "#1e90ff" : "#ff6b6b"}`,
                        width: 280,
                        minWidth: 280,
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span
                            style={{
                                width: 8,
                                height: 8,
                                borderRadius: "50%",
                                background: isLiveStarted ? "#ff2d2d" : "#ff6b6b",
                                boxShadow: isLiveStarted
                                    ? "0 0 0 4px rgba(255,45,45,0.18)"
                                    : "0 0 0 4px rgba(255,107,107,0.2)",
                                animation: isLiveStarted ? "liveToastPulse 1.2s ease-in-out infinite" : "none",
                            }}
                        />
                        <strong>{isLiveStarted ? "En vivo" : "Live finalizado"}</strong>
                    </div>
                    <div style={{ fontSize: 13, marginTop: 4 }}>
                        {deviceId ? `${message} (${deviceId})` : message}
                    </div>
                    {canOpenLive && (
                        <div style={{ fontSize: 12, marginTop: 6, color: "#1e90ff", fontWeight: 600 }}>
                            Click para abrir el live
                        </div>
                    )}
                    <div
                        style={{
                            marginTop: 8,
                            height: 3,
                            background: "#e6eef7",
                            borderRadius: 999,
                            overflow: "hidden",
                        }}
                    >
                        <div
                            style={{
                                height: "100%",
                                background: isLiveStarted ? "#1e90ff" : "#ff6b6b",
                                animation: `liveToastProgress ${durationMs}ms linear forwards`,
                            }}
                        />
                    </div>
                </div>
            ),
            {
                id: deviceId ? `security-live-${deviceId}-${isLiveStarted ? "start" : "end"}` : undefined,
                duration: durationMs,
            }
        );
    };

    toggleOffcanvasUser = () => {
        this.setState((prev) => ({
            offcanvasUser: !prev.offcanvasUser,
            hasNewNotification: false,
            // Si abres offcanvas, aseguras cerrar dropdown
            showNotificationDropdown: false,
        }));
    }

    openOffcanvas = () => {
        this.setState({
            offcanvasOpen: true,
            hasNewNotification: false,
            showNotificationDropdown: false,
        });
    };

    openOffcanvasUser = () => {
        this.setState({
            offcanvasUser: true,
            hasNewNotification: false,
            showNotificationDropdown: false,
        });
    };

    closeOffcanvas = () => {
        this.setState({ offcanvasOpen: false });
    };

    closeOffcanvasUser = () => {
        this.setState({ offcanvasUser: false });
    };

    handleUserInteraction = () => {
        this.setState({ audioReady: true });
        document.body.removeEventListener("click", this.handleUserInteraction);
    };

    playNotificationSound = () => {
        if (this.state.audioReady) {
            this.notificationSound.play().catch((error) => {
                console.error("Error al intentar reproducir el sonido:", error);
            });
        }
    };

    handleIncomingNotifications = (notifData) => {
        const incoming = this.normalizeNotificationPayload(notifData);
        if (incoming.length === 0) return;

        this.setState((prev) => {
            const current = prev.notifications || [];
            const merged = this.mergeNotifications(incoming, current);
            const newItems = incoming.filter(
                (nueva) =>
                    !current.some((noti) => this.normalizeNotificationId(noti) === this.normalizeNotificationId(nueva))
            );
            const itemsToAnnounce = newItems.filter((item) => this.shouldSpeakNotification(item));

            if (itemsToAnnounce.length > 0) {
                console.log("Nuevas notificaciones detectadas:", itemsToAnnounce);
                if (prev.bitOpen && Notification.permission === "granted") {
                    this.notificationSpeechQueue = this.notificationSpeechQueue.then(async () => {
                        for (const item of itemsToAnnounce) {
                            await showNotificationSpeech(item);
                        }
                    });

                    if (window.location.pathname !== "/mapCenter") {
                        this.playNotificationSound();
                    }
                }
            }

            if (merged.length === current.length) {
                return null;
            }

            return {
                filteredNotiofications: merged,
                notifications: merged,
                hasNewNotification: true,
            };
        });
    };

    triggerMockNotifications = () => {
        const baseId = 66;
        const nowIso = new Date().toISOString();
        const mocks = [1, 2, 3, 4, 5].map((i) => ({
            IdNotificacion: baseId + i,
            Notificacion: `Mock ${baseId + i}`,
            NotificacionCliente: `Mock cliente ${baseId + i}`,
            DatetimeNoti: nowIso,
            DatetimeEvento: nowIso,
            FkLokDeviceID: `DEV-MOCK-${baseId + i}`,
            FkLokContractID: `CTR-MOCK-${baseId + i}`,
            AlertLevel: 2,
        }));

        this.handleIncomingNotifications({ data: mocks });
    };

    normalizeNotificationPayload = (raw) => {
        if (!raw) return [];
        if (Array.isArray(raw)) return raw;
        if (Array.isArray(raw.data)) return raw.data;
        if (raw.data && typeof raw.data === "object") return [raw.data];
        if (typeof raw === "object") return [raw];
        return [];
    };

    normalizeNotificationId = (item) => {
        const id = item?.IdNotificacion ?? item?.IDNotificacion ?? item?.idNotificacion ?? item?.id;
        return id !== undefined && id !== null ? String(id) : null;
    };

    hasNewNotifiactions(newArrary, notysActual) {
        const incoming = Array.isArray(newArrary) ? newArrary : [];
        const current = Array.isArray(notysActual) ? notysActual : [];
        console.log("Comparando notificaciones, newArrary:", incoming, "notysActual:", current);
        if (incoming.length === 0) return false;
        if (current.length === 0) return true;
        const notiNoRepit = incoming.filter(
            (nueva) => !current.some((noti) => this.normalizeNotificationId(noti) === this.normalizeNotificationId(nueva))
        );
        return notiNoRepit.length > 0;
    }

    mergeNotifications = (incoming, current) => {
        const merged = [];
        const seen = new Set();
        const pushUnique = (item) => {
            const key = this.normalizeNotificationId(item);
            if (key !== null && seen.has(key)) return;
            if (key !== null) seen.add(key);
            merged.push(item);
        };

        (incoming || []).forEach(pushUnique);
        (current || []).forEach(pushUnique);
        return merged;
    };

    cleanupSpokenIds = () => {
        const now = Date.now();
        for (const [id, ts] of this.spokenNotificationIds.entries()) {
            if (now - ts > this.spokenTtlMs) {
                this.spokenNotificationIds.delete(id);
            }
        }
    };

    shouldSpeakNotification = (item) => {
        const id = this.normalizeNotificationId(item);
        if (!id) return true;
        this.cleanupSpokenIds();
        if (this.spokenNotificationIds.has(id)) return false;
        this.spokenNotificationIds.set(id, Date.now());
        return true;
    };

    connectSocket = () => {
        const token = localStorage.getItem("tkn");
        if (!token) return;

        if (typeof this.socketRetryCount !== "number") this.socketRetryCount = 0;
        if (typeof this.socketRetryTimer === "undefined") this.socketRetryTimer = null;

        if (window.__traficoSocketOwner && window.__traficoSocketOwner !== this.instanceId) {
            console.warn("Socket de tráfico ya activo en otra instancia. Se evita duplicado.");
            return;
        }

        if (this.socket) {
            try { this.socket.close(); } catch { }
        }

        try {
            this.socket = new WebSocket(
                `wss://${process.env.REACT_APP_SERVER_WEBSOCKET}/trafico/`,
                token
            );
            window.__traficoSocketOwner = this.instanceId;
            window.__traficoSocketRef = this.socket;

            this.socket.onopen = () => {
                this.socketRetryCount = 0;
                if (this.socketRetryTimer) {
                    clearTimeout(this.socketRetryTimer);
                    this.socketRetryTimer = null;
                }
                console.warn("WebSocket de tráfico conectado");
            };

            this.socket.onmessage = (event) => {
                try {
                    let raw = null;
                    try {
                        raw = JSON.parse(event.data);
                    } catch {
                        raw = event.data;
                    }
                    console.log("Mensaje bruto recibido en WebSocket de tráfico:", raw);

                    let msg = raw;
                    if (raw?.message && typeof raw.message === "string") {
                        try {
                            msg = JSON.parse(raw.message);
                        } catch {
                            msg = raw.message;
                        }
                    }

                    console.log("Mensaje tráfico recibido:", msg);

                    if (raw?.event === true) {
                        console.log("Ejecutando callback onUpdateSolicitudes con mensaje:", raw?.data);
                        // console.log("Cantidad de críticos recibidos por WebSocket:", (Array.isArray(raw?.data) ? raw.data : []).filter((item) => item?.EsCritico === 1).length);
                        // console.log("Cantidad de críticos recibidos por WebSocket:", (Array.isArray(raw?.data) ? raw.data : []).filter((item) => item?.ContractID === "SERV-00548521"));

                        this.props.onUpdateSolicitudes?.(raw.data);
                        console.log("Ejecutando callback differTime sin offset manual");
                        this.props.differTime?.(0);
                    }
                } catch (error) {
                    console.error("Error parseando mensaje tráfico:", error);
                }
            };

            this.socket.onerror = (error) => {
                console.error("Error en WebSocket tráfico:", error);
            };

            this.socket.onclose = (event) => {
                console.warn("Conexión tráfico cerrada:", event?.reason || "sin razón");
                if (window.__traficoSocketOwner === this.instanceId) {
                    window.__traficoSocketOwner = null;
                    window.__traficoSocketRef = null;
                }

                const delay = this.getBackoffDelay(this.socketRetryCount);
                this.socketRetryCount += 1;
                if (this.socketRetryTimer) clearTimeout(this.socketRetryTimer);
                this.socketRetryTimer = setTimeout(() => this.connectSocket(), delay);
            };
        } catch (error) {
            console.error("Fallo al conectar tráfico:", error);
        }
    };
    connectNotificationSocket = () => {
        const token = localStorage.getItem("tkn");
        if (!token) return;

        if (this.notificationSocket) {
            try { this.notificationSocket.close(); } catch { }
        }

        this.notificationSocket = new WebSocket(
            `wss://${process.env.REACT_APP_SERVER_WEBSOCKET}/notificaciones/`,
            token
        );

        this.notificationSocket.onopen = () => {
            console.warn("WebSocket de notificaciones conectado");
        };

        this.notificationSocket.onmessage = (event) => {
            const notifData = JSON.parse(event.data);
            console.log("Mensaje recibido en WebSocket de notificaciones:", notifData);
            if (notifData?.event === true && Array.isArray(notifData.data) && notifData.data.length > 0) {
                const firstNewNotif = notifData.data[0];
                console.log("Primera notificación del mensaje:", firstNewNotif);
                const isSecurityNotification = Number(firstNewNotif?.FkTipoNotificacion) === 2;
                const hasNewNotifications = this.hasNewNotifiactions(notifData.data, this.state.notifications);

                if (isSecurityNotification) {
                    this.showSecurityLiveToast(firstNewNotif);
                } else if (hasNewNotifications) {
                    console.log("Nueva notificación detectada:", firstNewNotif);

                    if (this.state.bitOpen && Notification.permission === "granted") {
                        showNotificationSpeech(firstNewNotif);

                        if (window.location.pathname !== "/mapCenter") {
                            this.playNotificationSound();
                        }

                        this.setState({
                            filteredNotiofications: notifData.data,
                            notifications: notifData.data,
                            hasNewNotification: true,
                        });
                    }
                }
            }
        };

        this.notificationSocket.onerror = (error) => {
            console.error("Error en la conexión WebSocket (notificaciones):", error);
        };

        this.notificationSocket.onclose = (event) => {
            console.error("Conexión cerrada (notificaciones):", event.reason);
            setTimeout(() => this.connectNotificationSocket(), 5000);
        };
    };

    connectLiveNotifications = async () => {
        const token = localStorage.getItem("tkn");
        if (!token) return;

        if (this.liveNotificationSocket) {
            try { this.liveNotificationSocket.close(); } catch { }
        }

        try {
            const liveSocketUrl = `wss://${process.env.REACT_APP_SERVER_WEBSOCKET}/get-live-token`;
            console.log("Conectando a WebSocket live en:", liveSocketUrl);

            this.liveNotificationSocket = new WebSocket(liveSocketUrl, token);

            this.liveNotificationSocket.onopen = () => {
                this.liveRetryCount = 0;
                if (this.liveRetryTimer) {
                    clearTimeout(this.liveRetryTimer);
                    this.liveRetryTimer = null;
                }
                console.warn("WebSocket live conectado");
            };

            this.liveNotificationSocket.onmessage = (event) => {
                console.log(event);
                try {
                    const raw = JSON.parse(event.data);
                    let msg = raw?.message;
                    if (typeof msg === "string") {
                        try {
                            msg = JSON.parse(msg);
                        } catch {
                            msg = { event: raw?.event, info: msg };
                        }
                    } else if (!msg || typeof msg !== "object") {
                        msg = raw;
                    }
                    console.log("Mensaje live recibido:", msg);
                    console.log("Mensaje live recibido:", msg?.event);
                    const eventName = String(msg?.event || "").toUpperCase();
                    const eventoName = String(msg?.evento || msg?.status || "").toUpperCase();
                    const isLiveStarted =
                        (eventName === "LIVE_NOW" && (eventoName === "STARTED" || eventoName === "START")) ||
                        eventName === "LIVE_START" ||
                        eventName === "LIVE_STARTED";

                    const isLiveEnded =
                        (eventName === "LIVE_NOW" && (eventoName === "FINISHED" || eventoName === "ENDED" || eventoName === "END" || eventoName === "STOPPED")) ||
                        eventName === "LIVE_END" ||
                        eventName === "LIVE_ENDED" ||
                        eventName === "LIVE_STOP" ||
                        eventName === "LIVE_FINISHED";

                    const normalizedLiveMsg = {
                        ...msg,
                        deviceId:
                            msg?.deviceId ||
                            msg?.deviceID ||
                            msg?.fkLokDeviceID ||
                            msg?.FKLokDeviceID ||
                            msg?.data?.deviceId ||
                            msg?.data?.deviceID ||
                            "",
                        streamId:
                            msg?.streamId ||
                            msg?.streamID ||
                            msg?.streamUrl ||
                            msg?.streamURL ||
                            msg?.url ||
                            msg?.data?.streamId ||
                            msg?.data?.streamUrl ||
                            msg?.data?.url ||
                            "",
                    };

                    if (isLiveStarted) {
                        if (typeof this.props.onLiveNow === "function") {
                            console.log("Ejecutando callback onLiveNow con mensaje:", msg?.event);
                            this.props.onLiveNow(normalizedLiveMsg);
                        } else {
                            alert(msg.info || "Transmision en vivo");
                        }
                    } else if (isLiveEnded) {
                        if (typeof this.props.onLiveEnded === "function") {
                            this.props.onLiveEnded(normalizedLiveMsg);
                        }
                        const deviceId = normalizedLiveMsg?.deviceId || "";
                        toast.custom(
                            (t) => (
                                <div
                                    style={{
                                        background: "#fff",
                                        color: "#111",
                                        padding: "10px 14px",
                                        borderRadius: 10,
                                        boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                                        borderLeft: "4px solid #ff6b6b",
                                        width: 280,
                                        minWidth: 280,
                                    }}
                                >
                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                        <span
                                            style={{
                                                width: 8,
                                                height: 8,
                                                borderRadius: "50%",
                                                background: "#ff6b6b",
                                                boxShadow: "0 0 0 4px rgba(255,107,107,0.2)",
                                            }}
                                        />
                                        <strong>Live finalizado</strong>
                                    </div>
                                    <div style={{ fontSize: 13, marginTop: 4 }}>
                                        {deviceId
                                            ? `El live del dispositivo terminó (${deviceId})`
                                            : "El live del dispositivo terminó"}
                                    </div>
                                </div>
                            ),
                            { id: deviceId ? `live-finished-${deviceId}` : undefined, duration: 5000 }
                        );
                    }
                } catch (error) {
                    console.error("Error parseando mensaje live:", error);
                }
            };

            this.liveNotificationSocket.onerror = (error) => {
                console.error("Error en WebSocket live:", error);
            };

            this.liveNotificationSocket.onclose = () => {
                const delay = this.getBackoffDelay(this.liveRetryCount);
                this.liveRetryCount += 1;
                if (this.liveRetryTimer) clearTimeout(this.liveRetryTimer);
                this.liveRetryTimer = setTimeout(() => this.connectLiveNotifications(), delay);
            };
        } catch (error) {
            console.error("Fallo al conectar live:", error);
        }
    };

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
        window.addEventListener("resize", this.handleResize);

        this.intervalId = setInterval(() => {
            this.setState({ currentTime: this.getCurrentTimeAdjustedByPreferredTimeZone() });
        }, 1000);

        const filterSolicitudes = this.props.filteredSolicitudes
            ? this.props.filteredSolicitudes.filter(
                (data) => data.estado === "Solicitud Cliente por Confirmar"
            )
            : [];

        const ordenadoPorIDDescendente = filterSolicitudes.sort((a, b) => {
            const numA = parseInt(String(a.IDSolicitudes || "").split("-")[1] || "0", 10);
            const numB = parseInt(String(b.IDSolicitudes || "").split("-")[1] || "0", 10);
            return numB - numA;
        });

        this.setState({ solicitudes: ordenadoPorIDDescendente });

        if (this.props.enableContractSocket !== false) {
            this.connectSocket();
        }
        if ("Notification" in window) {
            Notification.requestPermission().then((permission) => {
                if (permission === "granted") {
                    document.body.addEventListener("click", this.handleUserInteraction);
                    this.connectNotificationSocket();
                    this.connectLiveNotifications();
                }
            });
        }

        if (typeof this.props.onRegisterMock === "function") {
            this.props.onRegisterMock(this.triggerMockNotifications);
        }
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
        window.removeEventListener("resize", this.handleResize);
        document.body.removeEventListener("click", this.handleUserInteraction);

        if (this.socketRetryTimer) clearTimeout(this.socketRetryTimer);
        if (this.notificationRetryTimer) clearTimeout(this.notificationRetryTimer);
        if (this.liveRetryTimer) clearTimeout(this.liveRetryTimer);

        if (this.socket) this.socket.close();
        if (this.notificationSocket) this.notificationSocket.close();
        if (this.liveNotificationSocket) this.liveNotificationSocket.close();
        if (window.__traficoSocketOwner === this.instanceId) {
            window.__traficoSocketOwner = null;
            window.__traficoSocketRef = null;
        }
        if (window.__notificationSocketOwner === this.instanceId) {
            window.__notificationSocketOwner = null;
            window.__notificationSocketRef = null;
        }
        const prevCount = parseInt(sessionStorage.getItem(this.sessionConnKey) || "0", 10);
        sessionStorage.setItem(this.sessionConnKey, String(Math.max(0, prevCount - 1)));

        clearInterval(this.intervalId);

        if (typeof this.props.onRegisterMock === "function") {
            this.props.onRegisterMock(null);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.filteredSolicitudes !== this.props.filteredSolicitudes) {
            const filterSolicitudes = (this.props.filteredSolicitudes || []).filter(
                (data) => data.estado === "Solicitud Cliente por Confirmar"
            );

            const ordenadoPorIDDescendente = filterSolicitudes.sort((a, b) => {
                const numA = parseInt(String(a.IDSolicitudes || "").split("-")[1] || "0", 10);
                const numB = parseInt(String(b.IDSolicitudes || "").split("-")[1] || "0", 10);
                return numB - numA;
            });

            this.setState({ solicitudes: ordenadoPorIDDescendente });
        }
    }

    toggleNotificationDropdown() {
        this.setState((prevState) => ({
            showNotificationDropdown: !prevState.showNotificationDropdown,
            hasNewNotification: false,
            // si abre dropdown, cerrar offcanvas
            offcanvasOpen: false,
        }));
    }

    openModal() {
        this.setState({ openModal: true });
    }

    openModalChangePassword() {
        this.setState({ openModalChangePassword: true });
    }

    closeModalChangePassword() {
        this.setState({ openModalChangePassword: false });
    }

    closeModal() {
        this.setState({ openModal: false });
    }

    closeNotificationPanel = () => {
        this.setState({ showNotificationDropdown: false });
    };

    formatTimeForZone = (timeZone) => {
        try {
            return new Intl.DateTimeFormat("es-CO", {
                timeZone,
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
            }).format(this.state.currentTime);
        } catch {
            return "--";
        }
    };

    getTimePreviewData = () => {
        const activeZoneData = getCurrentTimeZoneData();
        const browserZone = localStorage.getItem("browser_time_zone") || getBrowserTimeZone();
        const activeZone = activeZoneData?.timeZone || browserZone;

        return {
            activeLabel: activeZoneData?.label || activeZone,
            activeTime: this.formatTimeForZone(activeZone),
            browserZone,
            browserTime: this.formatTimeForZone(browserZone),
        };
    };

    renderTimezonePreview = () => {
        const preview = this.getTimePreviewData();
        return (
            <div className="timezone-preview">
                <div className="timezone-preview-line">
                    <span className="timezone-preview-zone">{preview.activeLabel}</span>
                    <span className="timezone-preview-clock">{preview.activeTime}</span>
                </div>
            </div>
        );
    };

    handleClickOutside(event) {
        // Solo aplica al dropdown (desktop)
        if (this.state.isMobile) return;
        if (!this.state.showNotificationDropdown) return;

        if (
            this.dropdownRef.current &&
            this.bellIconRef.current &&
            !this.dropdownRef.current.contains(event.target) &&
            !this.bellIconRef.current.contains(event.target)
        ) {
            this.closeNotificationPanel();
        }
    }

    getAllNotifications = () => {
        axios
            .get(process.env.REACT_APP_SERVER + "/operaciones/getnotificaciones", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true,
            })
            .then((res) => {
                if (res.data.success === false) {
                    window.location.href = "/";
                } else {
                    const rows = res?.data?.data?.recordsets?.[0] || [];
                    console.log("Respuesta del servidor al obtener notificaciones:", res);
                    console.log("Notificaciones obtenidas del servidor:", rows);
                    if (rows.length > 0) {
                        this.setState({
                            filteredNotiofications: rows,
                            notifications: rows,
                            hasNewNotification: true,
                        });
                    } else {
                        this.setState({ hasNewNotification: false });
                    }
                }
            })
            .catch((err) => console.error(err));
    };

    HandlePageByRole = async () => {
        const data = { pagina: "21" };
        try {
            const res = await axios.post(
                process.env.REACT_APP_SERVER + "/usuarios/getconfiguracionpagina",
                JSON.stringify(data),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                    },
                    withCredentials: true,
                }
            );

            if (res.data.success === false) {
                window.location.href = "/";
                return;
            }

            const row = res?.data?.data?.[0];
            if (row) {
                this.setState({
                    bitOpen: !!row.bitOpen,
                    bitInsert: !!row.bitInsert,
                    bitEdit: !!row.bitEdit,
                    bitDelete: !!row.bitDelete,
                });

                if (row.bitOpen === true) {
                    this.getAllNotifications();
                    logAvailableVoices();
                }
            }
        } catch (error) {
            console.error("Error al listar bit permisos:", error);
        }
    };

    getCurrentTimeAdjustedByPreferredTimeZone = () => {
        return new Date();
    };

    getCurrentDateTime = () => {
        const now = new Date();
        const pad = (value) => String(value).padStart(2, "0");
        return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    };

    handleAceptarClick = (index) => {
        if (this.state.bitInsert) {
            this.setState({ confirmacionIndex: index, animatingIndex: index });
        } else {
            Swal.fire({
                title: "Información",
                text: "No tiene los permisos necesarios para aceptar la solicitud",
                icon: "info",
                showConfirmButton: false,
                timer: 3000,
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
        }
    };

    handleFilterNotify = (e) => {
        const searchValue = String(e.target.value || "").toLowerCase();

        if (!searchValue) {
            this.setState({ filteredNotiofications: this.state.notifications });
            return;
        }

        const filteredNotifications = (this.state.notifications || []).filter((notification) => {
            return Object.values(notification || {}).some((value) =>
                String(value || "").toLowerCase().includes(searchValue)
            );
        });

        this.setState({ filteredNotiofications: filteredNotifications });
    };

    handleSolicitudClick = (Solicitud) => {
        const fechaHora = this.getCurrentDateTime();

        const dataSolicitudReport = {
            FKLokEstadoID: 14,
            Nota: "",
            XTime: fechaHora,
            XUser: this.state.userSolicitud,
            FKLokSolicitudID: Solicitud.IDSolicitudes,
        };

        axios
            .post(
                process.env.REACT_APP_SERVER + "/solicitudes/setinsertReporteSolicitud",
                JSON.stringify(dataSolicitudReport),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                    },
                    withCredentials: true,
                }
            )
            .then((res) => {
                if (res.data.success === false) {
                    window.location = "/";
                } else {
                    this.props.ListarContratos?.();
                }
            })
            .catch((err) => console.error(err));
    };

    logout() {
        this.setState(
            {
                offcanvasOpen: false,
                offcanvasUser: false,
                showNotificationDropdown: false,
                showUserDropdown: false,
                openModal: false,
                openModalChangePassword: false,
            },
            () => {
                axios
                    .get(process.env.REACT_APP_SERVER + "/logout", {
                        headers: { "Content-Type": "application/json" },
                        withCredentials: true,
                    })
                    .then(() => {
                        localStorage.removeItem("tkn");
                        localStorage.removeItem("username");
                        localStorage.removeItem("companyId");
                        localStorage.removeItem("server");
                        localStorage.removeItem("isRefreshIntervalActive");
                        localStorage.removeItem("project");
                        localStorage.removeItem("idFilterSelected");
                        localStorage.removeItem("nameFilters");
                        localStorage.removeItem("arrayFilters");
                        sessionStorage.removeItem("trafico:arrayFilters");
                        localStorage.removeItem("global_expansion_state");
                        localStorage.removeItem("search");
                        sessionStorage.removeItem("trafico:search");
                        localStorage.removeItem("active_streams_v1");
                        sessionStorage.removeItem("active_streams_v1");

                        Object.keys(localStorage).forEach((key) => {
                            if (key.endsWith("_expanded")) localStorage.removeItem(key);
                        });

                        if (this.socket) this.socket.close();
                        if (this.notificationSocket) this.notificationSocket.close();

                        window.location.replace("/login");
                    });
            }
        );
    }

    // Panel de notificaciones: reutilizable para dropdown y offcanvas
    renderNotificationList() {
        const { filteredNotiofications, currentTime } = this.state;
        const visibleNotifications = (filteredNotiofications || []).filter(
            (notif) => Number(notif?.FkTipoNotificacion) !== 2
        );
        // console.log("Renderizando lista de notificaciones, filteredNotiofications:", filteredNotiofications);

        if (visibleNotifications.length === 0) {
            return <p style={{ textAlign: "center", padding: 10, color: "#555" }}>No hay notificaciones nuevas</p>;
        }

        return visibleNotifications.map((notif, index) => {
            // Usar la fecha TAL CUAL llega del backend/websocket (ya viene en hora local del servidor).
            // NO usar formatDateForPreferredTimeZone: causaba un desfase de +5 horas porque
            // el navegador interpreta la fecha sin zona como local y luego se le sumaba el
            // offset preferido encima (doble conversión).
            const rawNotiDate = String(notif.DatetimeNoti || "");
            const serverNotiDate = rawNotiDate
                .replace(" ", "T")
                .replace(/Z$/i, "")
                .replace(/[+-]\d{2}:?\d{2}$/, "");
            const safeNotifDate = serverNotiDate
                ? new Date(serverNotiDate)
                : new Date();
            const now = new Date(currentTime);

            const diffMs = now - safeNotifDate;
            const diffSeconds = Math.max(0, Math.floor(diffMs / 1000));
            const diffMinutes = Math.floor(diffSeconds / 60);
            const diffHours = Math.floor(diffMinutes / 60);

            let timeAgo = "";
            if (diffHours > 0) timeAgo = `${diffHours} ${diffHours === 1 ? "hora" : "horas"}`;
            else if (diffMinutes > 0) timeAgo = `${diffMinutes} ${diffMinutes === 1 ? "minuto" : "minutos"}`;
            else timeAgo = `${diffSeconds} ${diffSeconds === 1 ? "segundo" : "segundos"}`;

            const validateIcon = (alertLevel) => {
                if (alertLevel === 1) return <i className="bx bxs-lock-open" style={{ marginRight: 6, fontSize: "1.1rem", color: "#FF0000" }} />;
                if (alertLevel === 2) return <i className="bx bxs-error" style={{ marginRight: 6, fontSize: "1.1rem", color: "#ff9900" }} />;
                if (alertLevel === 3) return <i className="bx bxs-info-circle" style={{ marginRight: 6, fontSize: "1.1rem", color: "#006699" }} />;
                return null;
            };

            const validationColor = (levelalert) => {
                if (levelalert === 1) return "#FF0000";
                if (levelalert === 2) return "#ff9900";
                if (levelalert === 3) return "#006699";
                return "#000";
            };

            // DatetimeEvento llega en UTC; se ajusta a Colombia (UTC-5) antes de mostrarlo.
            const fechaHora = formatNotificationEventDate(notif.DatetimeEvento) || "--";

            return (
                <li key={notif.id || `notif-${index}`} style={{ listStyle: "none", marginBottom: 10 }}>
                    <div
                        className="notification-item"
                        style={{
                            borderLeft: `4px solid ${validationColor(notif.AlertLevel)}`,
                            borderRadius: 8,
                            padding: 10,
                            background: "#fff",
                            boxShadow: "0px 1px 2px rgba(0,0,0,0.08)",
                            display: "flex",
                            flexDirection: "column",
                            gap: 6,
                            flexWrap: "wrap",
                        }}
                    >
                        <div className="notification-title" style={{ color: "black" }}>
                            {validateIcon(notif.AlertLevel)}
                            <span className="notification-title-text" style={{ fontWeight: 600, fontSize: "1rem" }}>
                                {empresa === "2" ? notif.Notificacion : notif.NotificacionCliente}
                            </span>
                        </div>

                        <div style={{ fontSize: "0.85rem", color: "#555" }}>
                            <strong>Fecha/Hora del evento:</strong> {fechaHora}
                        </div>
                        <div style={{ fontSize: "0.85rem", color: "#555" }}>
                            <strong>Dispositivo:</strong> {notif.FkLokDeviceID}
                        </div>
                        <div style={{ fontSize: "0.85rem", color: "#555" }}>
                            <strong>Servicio:</strong> {notif.FkLokContractID}
                        </div>

                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <span style={{ fontSize: "0.8rem", color: "#999" }}>Hace {timeAgo}</span>
                        </div>
                    </div>
                </li>
            );
        });
    }

    render() {
        const visibleNotificationsCount = (this.state.notifications || []).filter(
            (notif) => Number(notif?.FkTipoNotificacion) !== 2
        ).length;
        const totalCount = (this.state.solicitudes?.length || 0) + visibleNotificationsCount;

        return (
            <>
                <nav
                    className="layout-navbar container-fluid navbar navbar-expand-xl align-items-center custom-navbar-admin platform-responsive-navbar"
                    id="layout-navbar"
                >
                    {typeof this.props.onToggleNavigation === "function" && (
                        <button
                            type="button"
                            className="platform-navbar-menu-toggle"
                            onClick={this.props.onToggleNavigation}
                            aria-label="Abrir menú de navegación"
                        >
                            <i className="bx bx-menu" aria-hidden="true"></i>
                        </button>
                    )}
                    <a href="/principal" className="app-brand-link">
                        <img alt="" className="style22" src="./Cargotronics.png" height="80" />
                    </a>
                    {/* V.G.1 */}
                    <div className="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
                        <ul className="navbar-nav flex-row align-items-center ms-auto navbar-actions">
                            {/* CAMPANA */}
                            {this.state.bitOpen && (
                                <li className="nav-item nav-notify">
                                    <button
                                        type="button"
                                        className="btn-reset"
                                        aria-label="Notificaciones"
                                        onClick={() =>
                                            this.state.isMobile ? this.openOffcanvas() : this.toggleNotificationDropdown()
                                        }
                                    >
                                        <i
                                            className={`bx bxs-bell-ring bx-md notification-icon ${this.state.hasNewNotification ? "bx-tada-hover-solicitudes" : ""
                                                }`}
                                            ref={this.bellIconRef}
                                        />
                                        <span className="notificationsCount">{totalCount}</span>
                                    </button>

                                    {/* DROPDOWN SOLO DESKTOP */}
                                    {!this.state.isMobile && this.state.showNotificationDropdown && (
                                        <ul
                                            className="dropdown-menu show"
                                            id="notificationDropdown"
                                            ref={this.dropdownRef}
                                            style={{
                                                position: "absolute",
                                                top: "100%",
                                                right: 0,
                                                width: 520,
                                                maxHeight: "calc(100vh - 200px)",
                                                overflow: "hidden",
                                                zIndex: 1000,
                                                backgroundColor: "#fff",
                                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                                borderRadius: 8,
                                                padding: 0,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    position: "sticky",
                                                    top: 0,
                                                    backgroundColor: "#fff",
                                                    zIndex: 2,
                                                    padding: 10,
                                                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                                                }}
                                            >
                                                <h5 style={{ textAlign: "center", margin: "0 0 10px", fontWeight: "bold", fontSize: "1rem" }}>
                                                    Notificaciones
                                                </h5>

                                                <div style={{ width: "90%", display: "flex", justifyContent: "center", margin: "0 auto 10px" }}>
                                                    <Input
                                                        placeholder="Buscar en las notificaciones..."
                                                        style={{ borderRadius: 10 }}
                                                        onChange={this.handleFilterNotify}
                                                    />
                                                </div>
                                            </div>

                                            <div
                                                className="dropdown-body-scroll"
                                                style={{ maxHeight: "calc(100vh - 300px)", overflowY: "auto", padding: 10 }}>
                                                {this.renderNotificationList()}
                                            </div>
                                        </ul>
                                    )}
                                </li>
                            )}

                            {/* USERNAME SOLO DESKTOP */}
                            <li className="nav-item d-none d-lg-block">
                                <span className="fw-semibold" style={{ marginRight: 6 }}>
                                    {userName || "John Doe"}
                                </span>
                            </li>

                            {/* AVATAR */}
                            <li className="nav-item navbar-dropdown dropdown-user dropdown nav-avatar">
                                {this.state.isMobile ? (
                                    <button
                                        type="button"
                                        className="btn-reset"
                                        onClick={this.openOffcanvasUser}
                                        aria-label="Abrir menú de usuario"
                                    >
                                        <img
                                            src="../assets/img/avatars/1.png"
                                            alt="avatar"
                                            className="avatar-img"
                                        />
                                    </button>
                                ) : (
                                    <>
                                        <a className="nav-link dropdown-toggle hide-arrow" data-bs-toggle="dropdown" href="#">
                                            <img
                                                src="../assets/img/avatars/1.png"
                                                alt="avatar"
                                                className="avatar-img"
                                            />
                                        </a>

                                        <ul className="dropdown-menu dropdown-menu-end">
                                            <li>
                                                <div className="dropdown-item">
                                                    <div className="d-flex">
                                                        <div className="flex-shrink-0 me-3" id="AvatarReponsive">
                                                            <div className="avatar avatar-online">
                                                                <img src="../assets/img/avatars/1.png" alt="" className="w-px-40 h-auto rounded-circle" />
                                                            </div>
                                                        </div>
                                                        <div className="flex-grow-1">
                                                            <span
                                                                className="fw-semibold d-block text-wrap"
                                                                style={{ maxWidth: 150, wordBreak: "break-all", whiteSpace: "normal" }}
                                                            >
                                                                {userName || "John Doe"}
                                                            </span>
                                                            <small className="text-muted">Admin</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>

                                            <li><div className="dropdown-divider"></div></li>
                                            <li>{this.renderTimezonePreview()}</li>
                                            <li><div className="dropdown-divider"></div></li>

                                            <li>
                                                <a className="dropdown-item" href="/myprofile">
                                                    <i className="bx bx-user me-2"></i>
                                                    <span className="align-middle">My Profile</span>
                                                </a>
                                            </li>

                                            <li>
                                                <a className="dropdown-item" href="/myprofile#timezone-settings">
                                                    <i className="bx bx-time-five me-2"></i>
                                                    <span className="align-middle">Zona horaria</span>
                                                </a>
                                            </li>

                                            <li>
                                                <button
                                                    type="button"
                                                    className="dropdown-item"
                                                    onClick={this.openModal}
                                                    data-bs-target="#ModalSettings"
                                                    data-bs-toggle="modal"
                                                >
                                                    <i className="bx bx-cog me-2"></i>
                                                    <span className="align-middle">Settings</span>
                                                </button>
                                            </li>

                                            <li>
                                                <button type="button" className="dropdown-item" onClick={this.openModalChangePassword}>
                                                    <i className="bx bx-lock me-2"></i>
                                                    <span className="align-middle">Cambiar contraseña</span>
                                                </button>
                                            </li>

                                            <li><div className="dropdown-divider"></div></li>

                                            <li>
                                                <button type="button" className="dropdown-item" onClick={() => this.logout()}>
                                                    <i className="bx bx-power-off me-2"></i>
                                                    <span className="align-middle">Log Out</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </>
                                )}
                            </li>
                        </ul>
                    </div>
                </nav>

                {/* ✅ OFFCANVAS REACTSTRAP SOLO EN MOBILE */}
                <Offcanvas
                    isOpen={this.state.offcanvasOpen}
                    toggle={this.toggleOffcanvas}
                    direction="end"
                    fade={false}
                    className="trafico-responsive-offcanvas"
                    style={{
                        width: "100vw",
                        maxWidth: "100vw",
                    }}
                >
                    <OffcanvasHeader toggle={this.toggleOffcanvas}>
                        Notificaciones
                    </OffcanvasHeader>

                    <OffcanvasBody style={{ paddingTop: 10 }}>
                        <div style={{ marginBottom: 12 }}>
                            <Input
                                placeholder="Buscar en las notificaciones..."
                                onChange={this.handleFilterNotify}
                                className="inputSearchNotifiaciones"
                            />
                        </div>

                        <div style={{ overflowY: "auto" }}>
                            <ul style={{ paddingLeft: 0, marginBottom: 0 }}>
                                {this.renderNotificationList()}
                            </ul>
                        </div>
                    </OffcanvasBody>
                </Offcanvas>

                <Offcanvas
                    isOpen={this.state.offcanvasUser}
                    toggle={this.toggleOffcanvasUser}
                    direction="end"
                    fade={false}
                    className="trafico-responsive-offcanvas"
                    style={{
                        width: "100vw",
                        maxWidth: "100vw",
                    }}
                >
                    <OffcanvasHeader toggle={this.toggleOffcanvasUser}>
                        Mi cuenta
                    </OffcanvasHeader>

                    <OffcanvasBody>
                        <div className="text-center mb-4">
                            <img
                                src="../assets/img/avatars/1.png"
                                alt="avatar"
                                className="rounded-circle mb-2"
                                width="72"
                            />
                            <h6 className="mb-0">{userName}</h6>
                            <small className="text-muted">Admin</small>
                        </div>

                        {this.renderTimezonePreview()}

                        <Button
                            color="light"
                            className="w-[90%] mb-2 text-start"
                            onClick={() => (window.location.href = "/myprofile")}
                        >
                            <i className="bx bx-user me-2"></i>
                            Mi perfil
                        </Button>

                        <Button
                            color="light"
                            className="w-100 mb-2 text-start"
                            onClick={() => (window.location.href = "/myprofile#timezone-settings")}
                        >
                            <i className="bx bx-time-five me-2"></i>
                            Zona horaria
                        </Button>

                        <Button
                            color="light"
                            className="w-100 mb-2 text-start"
                            onClick={this.openModal}
                            data-bs-toggle="modal"
                            data-bs-target="#ModalSettings"
                        >
                            <i className="bx bx-cog me-2"></i>
                            Configuración
                        </Button>

                        <Button
                            color="light"
                            className="w-100 mb-2 text-start"
                            onClick={this.openModalChangePassword}
                        >
                            <i className="bx bx-lock me-2"></i>
                            Cambiar contraseña
                        </Button>

                        <hr />

                        <Button
                            color="light"
                            className="w-100 text-start"
                            onClick={() => this.logout()}
                        >
                            <i className="bx bx-power-off me-2"></i>
                            Cerrar sesión
                        </Button>
                    </OffcanvasBody>
                </Offcanvas>


                {/* Modals */}
                <div className="modal fade" id="settingsModal" data-bs-backdrop="static" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <p>Set</p>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <SettingsModal isOpen={this.state.openModal} onClose={this.closeModal} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="ModalSettings" data-bs-backdrop="static" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <form className="modal-content" id="ModalSettings">
                            <div className="modal-header">
                                <h5 className="modal-title" id="backDropModalTitle">
                                    Base de datos: {server === "Prod" ? "Producción" : "Pruebas"}
                                </h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.closeModal}></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <SettingsModal isOpen={this.state.openModal} onClose={this.closeModal} />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <ModalBaseSm
                    isOpen={this.state.openModalChangePassword}
                    title={"Cambiar contraseña"}
                    onClose={this.closeModalChangePassword}
                    childComponent={<FormUpdatePassword onClose={this.closeModalChangePassword} />}
                />
            </>
        );
    }
}

const withNavigation = (Component) => {
    return function WithNavigation(props) {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    };
};

export default withNavigation(BarraTrafico);
